import { Typography } from "@material-ui/core";
import { FC } from "react";
import { qar } from "../../../../utils/generic";

const RequestPrice: FC<any> = (props) => {
  return <Typography>{qar(props.record.service.price * props.record.requestsNumber)}</Typography>;
};

export default RequestPrice;
